export function getBaseUrl(doc: Document) {
    const contextPath = "/exactag-customer-tracking"
    const location = doc.location
    return location.protocol + "/*                             */
}
